module.exports = __webpack_public_path__ + "img/Workflow-ability-02.d7324408.png";